module.exports = __webpack_public_path__ + "img/user.e622f9f0.png";